import { Skeleton } from "@/components/ui/skeleton";

interface LoadingSkeletonProps {
  rows?: number;
  type?: "table" | "cards";
}

const LoadingSkeleton = ({ rows = 5, type = "table" }: LoadingSkeletonProps) => {
  if (type === "cards") {
    return (
      <div className="space-y-3" role="status" aria-label="جاري التحميل">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="bg-card border border-border rounded-xl p-4 flex items-center gap-4">
            <Skeleton className="w-10 h-10 rounded-full flex-shrink-0" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-3 w-48" />
            </div>
            <Skeleton className="w-16 h-8 rounded-lg" />
          </div>
        ))}
        <span className="sr-only">جاري تحميل البيانات...</span>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded-xl border border-border" role="status" aria-label="جاري التحميل">
      <table className="w-full">
        <thead>
          <tr className="bg-table-header border-b border-border">
            <th className="px-4 py-4"><Skeleton className="h-4 w-16" /></th>
            <th className="px-4 py-4"><Skeleton className="h-4 w-24" /></th>
            <th className="px-4 py-4"><Skeleton className="h-4 w-32" /></th>
            <th className="px-4 py-4"><Skeleton className="h-4 w-12" /></th>
            <th className="px-4 py-4"><Skeleton className="h-4 w-16" /></th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <tr key={i} className={`border-b border-border/50 ${i % 2 === 0 ? 'bg-table-row-even' : 'bg-table-row-odd'}`}>
              <td className="px-4 py-3"><Skeleton className="w-8 h-8 rounded-full" /></td>
              <td className="px-4 py-3"><Skeleton className="h-4 w-28" /></td>
              <td className="px-4 py-3"><Skeleton className="h-4 w-36" /></td>
              <td className="px-4 py-3"><Skeleton className="h-4 w-10" /></td>
              <td className="px-4 py-3"><Skeleton className="h-6 w-14 rounded-lg" /></td>
            </tr>
          ))}
        </tbody>
      </table>
      <span className="sr-only">جاري تحميل البيانات...</span>
    </div>
  );
};

export default LoadingSkeleton;
